import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'self-service',
});

export const jenkinsRouteRef = createSubRouteRef({
  id: 'self-service-jenkins',
  parent: rootRouteRef,
  path: '/jenkins',
});

export const awsRouteRef = createSubRouteRef({
  id: 'self-service-aws',
  parent: rootRouteRef,
  path: '/aws',
});

export const azureRouteRef = createSubRouteRef({
  id: 'self-service-azure',
  parent: rootRouteRef,
  path: '/azure',
});

export const gcpRouteRef = createSubRouteRef({
  id: 'self-service-gcp',
  parent: rootRouteRef,
  path: '/gcp',
});
